import {Image, ImageProps} from "antd";

export const EmbedImage = (props: ImageProps) => {
	return <Image {...props}/>
}

export default EmbedImage;